export const ASSIGNEE_TYPES = [
    { label: 'Project default', value: 'PROJECT_DEFAULT' },
    { label: 'Project lead', value: 'PROJECT_LEAD' },
    { label: 'Component lead', value: 'COMPONENT_LEAD' },
    { label: 'Unassigned', value: 'UNASSIGNED' },
];

export const ASSIGNEE_TYPES_OBJECT = {
    PROJECT_DEFAULT: 'Project default',
    PROJECT_LEAD: 'Project lead',
    COMPONENT_LEAD: 'Component lead',
    UNASSIGNED: 'Unassigned',
};
